import { useFormContext } from 'react-hook-form';
import { BoxProps } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { IStepper } from 'types';
import { Logo } from 'assets';

import * as S from './Stepper.styled';

interface IProps extends BoxProps {
  activeStep: number;
  steps: IStepper[];
}

export const Stepper = ({ activeStep, steps, ...rest }: IProps) => {
  const { getValues } = useFormContext();

  const handleSelectedLength = (name: string): number => {
    const values: string[] | File[] = getValues(name);

    return values.length;
  };

  return (
    <S.Container {...rest}>
      <S.Stepper activeStep={activeStep}>
        {steps.map(({ label, summaryLabel }, index) => (
          <S.Step key={`step-item-${label}`}>
            <S.StepLabel
              icon={
                activeStep > index && !handleSelectedLength(label) ? (
                  <CancelIcon color="error" />
                ) : null
              }
              error={activeStep > index && !handleSelectedLength(label)}
              optional={
                <S.SummaryLabelWrapper>
                  {activeStep > index && (
                    <S.SummaryLabel>
                      {handleSelectedLength(label)
                        ? `${handleSelectedLength(label)} ${summaryLabel}`
                        : 'skipped'}
                      <S.StepIcon />
                    </S.SummaryLabel>
                  )}
                </S.SummaryLabelWrapper>
              }
            >
              {label}
            </S.StepLabel>
          </S.Step>
        ))}
      </S.Stepper>
      <S.LogoWrapper>
        <img src={Logo} alt="logo" />
      </S.LogoWrapper>
    </S.Container>
  );
};
